import 'regenerator-runtime';
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
// import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const getParams = ({ products, orderType, sapPartnerId }) => {
    const salesOrgList = [];
    products &&
        products.forEach((product) => {
            product.productCFN
                ? salesOrgList.push(product.productCFN)
                : salesOrgList.push(product.cfn);
        });
    return convertObjectToQueryParams({
        productCFN: salesOrgList.join(),
        sapPartnerId,
        orderType,
    });
};

export default function* getPricesForConsignmentItemsSaga(action) {
    const productCFN = action.payload ? action.payload.productCFN:'';
    const sapPartnerId = action.payload ? action.payload.sapPartnerId:'';
    const orderType = action.payload ? action.payload.orderType:'';
    const territoryId = action.payload ? action.payload.territoryId:'';
    const url = `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/price?productCFN=${encodeURIComponent(productCFN)}&sapPartnerId=${encodeURIComponent(sapPartnerId)}&orderType=${encodeURIComponent(orderType)}&territoryId=${encodeURIComponent(territoryId)}`;
    try {
        const result = yield axios({
            method: 'get',
            url: url,
        }).then((response) => response.data);
        yield put({
            type: GET_PRICES_FOR_ITEMS_SUCCESS,
            payload: {
                items: result.priceDetails,
                isPricingDone: true,
            },
        });
    } catch (e) {        
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRICES_FOR_ITEMS_FAILURE,
            payload: { items: [], isPricingDone: false },
        });
    }
}
